export default defineNuxtRouteMiddleware(async () => {
  const { $apis, $toast, $keycloak, $store } = useNuxtApp()

  if (!$keycloak.authenticated) {
    const redirectPath = encodeURIComponent(window.location.pathname)
    return navigateTo(`/login?redirect=${redirectPath}`)
  }

  try {
    if (!localStorage.getItem('tenant')) {
      const response = await $apis.tenants.fetchData($store.companies.subdomain)
      if (response?.id) {
        localStorage.setItem('tenant', response.id)
      }
    }
  }
  catch (error) {
    console.error('Error fetching user or tenant data', error)
    if ((error as Error).message === 'Unauthorized Access') {
      return navigateTo('/login')
    }

    $toast.warning((error as Error).message)
  }

  const { isTenantSubscriptionExpired } = useFeatureFlag()
  console.log('isTenantSubscriptionExpired', isTenantSubscriptionExpired())
  if (isTenantSubscriptionExpired()) {
    return navigateTo('/errors/ErrorSubscriptionExpired')
  }
})
